import { RouterPaths } from "../../../app/appConstants";

export const ONBOARDING_TUTORIAL_IMAGES = {
    CLOSE_POSITION_BG: 'tutorial-close-position-bg-{{locale}}.png',
    LOTS_BG: 'tutorial-lots-bg-{{locale}}.png',
    MAIN_SCREEN_BG: 'tutorial-main-screen-bg-{{locale}}.png',
    MARGIN_IMPACT_BG: 'tutorial-margin-impact-bg-{{locale}}.png',
    OPEN_POSITION_BG: 'tutorial-open-position-bg-{{locale}}.png',
    PORTFOLIO_BG: 'tutorial-portfolio-bg-{{locale}}.png',
    PROFIT_LOSS_BG: 'tutorial-profit-loss-bg-{{locale}}.png',
    WATCHLIST_BG: 'tutorial-watchlist-bg-{{locale}}.png',
}

export const PRELOAD_IMAGES_URLS_ONBOARDING_INITIAL = [
    ONBOARDING_TUTORIAL_IMAGES.CLOSE_POSITION_BG,
    ONBOARDING_TUTORIAL_IMAGES.MAIN_SCREEN_BG,
    ONBOARDING_TUTORIAL_IMAGES.OPEN_POSITION_BG,
    ONBOARDING_TUTORIAL_IMAGES.PORTFOLIO_BG,
    ONBOARDING_TUTORIAL_IMAGES.WATCHLIST_BG,
];

export const PRELOAD_IMAGES_URLS_ONBOARDING_REPEATED = [
    ONBOARDING_TUTORIAL_IMAGES.CLOSE_POSITION_BG,
    ONBOARDING_TUTORIAL_IMAGES.MAIN_SCREEN_BG,
    ONBOARDING_TUTORIAL_IMAGES.MARGIN_IMPACT_BG,
    ONBOARDING_TUTORIAL_IMAGES.LOTS_BG,
    ONBOARDING_TUTORIAL_IMAGES.OPEN_POSITION_BG,
    ONBOARDING_TUTORIAL_IMAGES.PORTFOLIO_BG,
    ONBOARDING_TUTORIAL_IMAGES.PROFIT_LOSS_BG,
    ONBOARDING_TUTORIAL_IMAGES.WATCHLIST_BG,
];

export const ONBOARDING_TUTORIAL_REDIRECT_ROUTES = {
    PREVIOUS_ROUTE: RouterPaths.onboardingWelcome,
    NEXT_ROUTE: RouterPaths.onboardingCongratulations,
};

export const ONBOARDING_TUTORIAL_STEP_NAMES = {
    CLOSE_POSITION: 'ClosePosition',
    LOTS: 'Lots',
    MARGIN_IMPACT: 'MarginImpact',
    OPEN_POSITION: 'OpenPosition',
    PORTFOLIO: 'Portfolio',
    PROFIT_LOSS: 'ProfitLoss',
    SELECT_ORDER_SIDE: 'SelectOrderSide',
    WATCHLIST: 'WatchList',
};
